<template>
      <a-col>
          <div>
            <a-list item-layout="horizontal" :split="true" :data-source="pointsInfor" class="points_list_container">
                <a-list-item slot="renderItem" slot-scope="item,index" @click="$router.go(-1)">
                    <div class="list_serial_num">
                        <span>{{(index + 1) >= 10 ? index + 1 : `0${index + 1}`}}</span>
                    </div>
                    <div class="list_content">
                        <span>
                            <img src="../../assets/icons/map_clock_icon.svg" alt="" class="clock_icon">
                            {{moment(item.tick).format('HH:mm:ss')}}
                        </span>
                        <span>
                            <img src="../../assets/icons/detail_car_status.svg" alt="">{{item.can.speed}} km/h
                        </span>
                        <span>
                            <img src="../../assets/icons/mileage.svg" alt="" class="mileage_icon">
                            {{3841}}km
                        </span>
                        <span>
                            <img src="../../assets/icons/map_location_icon.svg" alt="" class="location_icon">{{item.gps.lon}}, {{item.gps.lat}}
                        </span>
                    </div>
                </a-list-item>
            </a-list>
          </div>
      </a-col>
</template>

<script>
    // 假資料
    import { testScheduleListData } from "../../assets/testScheduleListData";

    export default {
        data() {
            return {
                pointsInfor: [],
            }
        },
        mounted() {
            this.pointsInfor= testScheduleListData['60f2997a2f200a00122fcfc5'].filter(obj => obj.gps.lon && obj.gps.lat);
        },
        methods: {
            turnToDetailData(param) {
                this.$router.push(`schedule/detail/${param}`);
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/global.scss";

    .points_list_container {
        padding: 0 12px;
        .ant-list-item {
            justify-content: flex-start;
            padding: 15px 0;
            align-items: stretch;
            &:first-child {
                padding-top: 0;
            }
            .list_serial_num {
                flex-basis: 10%;
                span {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: rgba(52, 55, 65, 0.6);
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 24px;
                    padding: 0 15px 0 4px;
                }
            }
            .list_content {
                flex-basis: 88%;
                display: flex;
                flex-wrap: wrap;
                span {
                    color: #343741;
                    line-height: 24px;
                    &:nth-child(odd) {
                        flex-basis: 37%;
                        display: flex;
                        align-items: center;
                    }
                    &:nth-child(even) {
                        flex-basis: 63%;
                    }
                    &:first-child, &:nth-child(2) {
                        margin-bottom: 6px;
                    }
                    img {
                        margin-right: 12px;
                    }
                    .clock_icon {
                        width: 16px;
                    }
                    .mileage_icon {
                        width: 17px;
                    }
                    .location_icon{
                        width: 14px;
                        margin-left: 2px;
                    }
                }
            }
        }
    }
    @media (max-width: 320px) {
        .points_list_container {
            .ant-list-item {
                .list_content {
                    flex-basis: 87%;
                    span {
                        font-size: 12px;
                    }
                }
            }
        }
    }
</style>